module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.victimCondition && this.victimCondition.injury) ? _c('div', {
    staticClass: "text-center"
  }, [(this.frontWounds.length || this.backWounds.length) ? [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row flex-row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(this.victimCondition.woundImage) ? _c('img', {
    staticClass: "img-thumbnail img-responsive",
    attrs: {
      "src": 'data:image/png;base64,' + this.victimCondition.woundImage,
      "alt": "Frontside injuries"
    }
  }) : _c('div', {
    staticClass: "caption"
  }, [_c('span', [_vm._v("No wounds")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(this.victimCondition.backWoundImage) ? _c('img', {
    staticClass: "img-thumbnail img-responsive",
    attrs: {
      "src": 'data:image/png;base64,' + this.victimCondition.backWoundImage,
      "alt": "Backside injuries"
    }
  }) : _c('div', {
    staticClass: "caption"
  }, [_c('span', [_vm._v("No wounds")])])])])] : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Victim injured - no wounds specified")])], 2) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Victim not injured")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row injuries-caption"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_c('strong', [_vm._v("Legend")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-left"
  }, [_c('span', {
    staticClass: "injury-type",
    staticStyle: {
      "background-color": "rgb(175, 36, 42)"
    }
  }), _vm._v(" "), _c('span', [_vm._v("External injuries")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "injury-type",
    staticStyle: {
      "background-color": "rgb(35, 31, 32)"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Internal injuries")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "injury-type",
    staticStyle: {
      "background-color": "rgb(105, 33, 37)"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Both internal and external injuries")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row details"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v("Frontside")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v("Backside")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fd051f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Injuries.vue
// module id = 445
// module chunks = 1